/**
 * Amplitude - 13 Eventos Customizados - KimonoLab
 * Usa amplitude.track() e window.trackAmplitude()
 */
(function() {
  'use strict';

  function trackAmplitude(eventName, eventProperties) {
    if (typeof window.amplitude !== 'undefined' && typeof window.amplitude.track === 'function') {
      try {
        window.amplitude.track(eventName, eventProperties || {});
      } catch (e) {
        console.warn('[Amplitude] Erro:', eventName, e);
      }
    }
  }
  window.trackAmplitude = trackAmplitude;

  function getUTMParams() {
    var params = {};
    try {
      var search = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function(k) {
        var v = search.get(k);
        if (v) params[k] = v;
      });
    } catch (e) {}
    return params;
  }

  // --- EVENTO 1: Page Viewed --- (custom, mantido)
  function initPageViewed() {
    document.addEventListener('DOMContentLoaded', function() {
      try {
        var utm = getUTMParams();
        trackAmplitude('Page Viewed', {
          page_url: window.location.href,
          page_title: document.title || '',
          referrer: document.referrer || '',
          utm_source: utm.utm_source || '',
          utm_medium: utm.utm_medium || '',
          utm_campaign: utm.utm_campaign || '',
          page_type: (window.theme && window.theme.pageType) ? window.theme.pageType : ''
        });
      } catch (e) {
        console.warn('[Amplitude] Page Viewed:', e);
      }
    });
  }

  // --- EVENTO 2: Product Viewed --- (dados injetados via Liquid em main-product)
  // Executado por script inline quando window.__AMPLITUDE_PRODUCT existe

  // --- EVENTO 3: Variant Selected ---
  function initVariantSelected() {
    document.addEventListener('DOMContentLoaded', function() {
      var productData = window.__AMPLITUDE_PRODUCT || {};
      var radios = document.querySelectorAll('variant-radios input[type="radio"]');
      var selects = document.querySelectorAll('variant-selects select');
      radios.forEach(function(input) {
        input.addEventListener('change', function() {
          try {
            trackAmplitude('Variant Selected', {
              product_id: productData.id || '',
              product_title: productData.title || '',
              option_name: this.name || '',
              option_value: this.value || ''
            });
          } catch (e) {}
        });
      });
      selects.forEach(function(select) {
        select.addEventListener('change', function() {
          try {
            var opt = select.options[select.selectedIndex];
            trackAmplitude('Variant Selected', {
              product_id: productData.id || '',
              product_title: productData.title || '',
              option_name: select.name || select.id || '',
              option_value: opt ? opt.value : ''
            });
          } catch (e) {}
        });
      });
    });
  }

  // --- EVENTO 4: Add To Cart --- (click no botão + form submit + pubsub)
  function initAddToCart() {
    var lastAddToCartTime = 0;
    function fireAddToCart(form) {
      if (!form) return;
      var now = Date.now();
      if (now - lastAddToCartTime < 500) return;
      lastAddToCartTime = now;
      try {
        var productData = window.__AMPLITUDE_PRODUCT || {};
        var variantInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var variantId = variantInput ? variantInput.value : '';
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var price = productData.price || '';
        if (productData.id || variantId) {
          trackAmplitude('Add To Cart', {
            product_id: productData.id || '',
            product_title: productData.title || '',
            variant_id: variantId,
            quantity: qty,
            price: price || ''
          });
        }
      } catch (e) {}
    }
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-action="add-to-cart"], .product-form__add-button:not(.product-form__submit--loading)');
      if (btn) {
        var form = btn.closest('form');
        if (form) fireAddToCart(form);
      }
    }, true);
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form && (form.classList.contains('product-form') || form.getAttribute('data-type') === 'add-to-cart-form' || form.action.indexOf('/cart/add') !== -1)) {
        fireAddToCart(form);
      }
    }, true);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(data) {
        if (data && data.source === 'product-form') {
          var form = document.querySelector('form.product-form, form[data-type="add-to-cart-form"], product-form form');
          if (form) fireAddToCart(form);
        }
      });
    }
  }

  // --- EVENTO 5: Cart Viewed ---
  function initCartViewed() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            try {
              fetch((window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart') + '.js')
                .then(function(r) { return r.json(); })
                .then(function(cart) {
                  trackAmplitude('Cart Viewed', {
                    cart_total: cart.total_price || 0,
                    item_count: cart.item_count || 0
                  });
                })
                .catch(function() {});
            } catch (e) {}
          }
        }
      });
    });
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // --- EVENTO 6: Remove From Cart ---
  function initRemoveFromCart() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('cart-remove-button');
      if (btn) {
        try {
          var row = btn.closest('tr.cart-item');
          if (row) {
            trackAmplitude('Remove From Cart', {
              product_id: row.getAttribute('data-product-id') || '',
              product_title: row.getAttribute('data-product-title') || '',
              variant_id: row.getAttribute('data-variant-id') || '',
              price: row.getAttribute('data-line-price') || ''
            });
          }
        } catch (err) {}
      }
    }, true);
  }

  // --- EVENTO 7: Checkout Started ---
  function initCheckoutStarted() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('button[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button');
      var link = e.target.closest('a[href*="/checkout"]');
      if (btn || link) {
        try {
          fetch((window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart') + '.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              trackAmplitude('Checkout Started', {
                cart_total: cart.total_price || 0,
                item_count: cart.item_count || 0
              });
            })
            .catch(function() {});
        } catch (err) {}
      }
    }, true);
  }

  // --- EVENTO 9: Collection Viewed --- (dados injetados via Liquid)
  // Executado por script inline quando window.__AMPLITUDE_COLLECTION existe

  // --- EVENTO 10: Product Search --- (disparado na página de resultados via __AMPLITUDE_SEARCH)
  // Form submit do header redireciona; o evento é disparado ao carregar a página de resultados

  // --- EVENTO 12: Size Guide Viewed ---
  function initSizeGuideViewed() {
    document.addEventListener('click', function(e) {
      var summary = e.target.closest('.product__accordion details summary, .accordion details summary');
      if (summary) {
        try {
          var titleEl = summary.querySelector('.accordion__title');
          var title = titleEl ? (titleEl.textContent || '').toLowerCase() : '';
          if (title.indexOf('tamanho') !== -1 || title.indexOf('size') !== -1 || title.indexOf('guia') !== -1) {
            var productData = window.__AMPLITUDE_PRODUCT || {};
            trackAmplitude('Size Guide Viewed', {
              product_id: productData.id || '',
              product_title: productData.title || ''
            });
          }
        } catch (err) {}
      }
      var popupBtn = e.target.closest('.product-popup-modal__button');
      if (popupBtn) {
        var btnText = (popupBtn.textContent || '').toLowerCase();
        if (btnText.indexOf('tamanho') !== -1 || btnText.indexOf('size') !== -1 || btnText.indexOf('guia') !== -1) {
          try {
            var productData = window.__AMPLITUDE_PRODUCT || {};
            trackAmplitude('Size Guide Viewed', {
              product_id: productData.id || '',
              product_title: productData.title || ''
            });
          } catch (err) {}
        }
      }
    }, true);
  }

  // --- EVENTO 13: Account Created ---
  function initAccountCreated() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (form && form.action && form.action.indexOf('/account') !== -1) {
        var isRegister = window.location.pathname.indexOf('register') !== -1;
        var hasPassword = form.querySelector('input[name="customer[password]"]');
        if (isRegister && hasPassword) {
          try {
            trackAmplitude('Account Created', {
              method: 'email',
              referrer: document.referrer || '',
              utm_source: getUTMParams().utm_source || ''
            });
          } catch (err) {}
        }
      }
    }, true);
  }

  // Inicializar todos
  initPageViewed();
  initVariantSelected();
  initAddToCart();
  initCartViewed();
  initRemoveFromCart();
  initCheckoutStarted();
  initSizeGuideViewed();
  initAccountCreated();

  // Product Viewed - dispara quando __AMPLITUDE_PRODUCT está disponível (página de produto)
  // Usa DOMContentLoaded + fallback para garantir que product-template já renderizou
  var productViewedFired = false;
  function fireProductViewed() {
    if (productViewedFired) return;
    if (window.__AMPLITUDE_PRODUCT && window.__AMPLITUDE_PRODUCT.id) {
      try {
        productViewedFired = true;
        trackAmplitude('Product Viewed', {
          product_id: window.__AMPLITUDE_PRODUCT.id,
          product_title: window.__AMPLITUDE_PRODUCT.title || '',
          price: window.__AMPLITUDE_PRODUCT.price || '',
          category: window.__AMPLITUDE_PRODUCT.type || '',
          variant_id: window.__AMPLITUDE_PRODUCT.variantId || ''
        });
      } catch (e) { productViewedFired = false; }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fireProductViewed);
  } else {
    fireProductViewed();
  }
  setTimeout(fireProductViewed, 800);

  // Collection Viewed - chamado por script inline quando __AMPLITUDE_COLLECTION está disponível
  if (window.__AMPLITUDE_COLLECTION && (window.__AMPLITUDE_COLLECTION.handle || window.__AMPLITUDE_COLLECTION.title)) {
    try {
      trackAmplitude('Collection Viewed', {
        collection_name: window.__AMPLITUDE_COLLECTION.title || '',
        collection_handle: window.__AMPLITUDE_COLLECTION.handle || '',
        products_count: window.__AMPLITUDE_COLLECTION.products_count || 0
      });
    } catch (e) {}
  }

  // Product Search - disparado na página de resultados quando __AMPLITUDE_SEARCH está disponível
  if (window.__AMPLITUDE_SEARCH && window.__AMPLITUDE_SEARCH.search_term) {
    try {
      trackAmplitude('Product Search', {
        search_term: window.__AMPLITUDE_SEARCH.search_term || '',
        results_count: window.__AMPLITUDE_SEARCH.results_count || 0
      });
    } catch (e) {}
  }

  window.AmplitudeEvents = { track: trackAmplitude };
})();
